import { atan2 } from "../util/math/Math"
import type { TilePositionXY } from "./TilePositionXY.type"

export default function getAngleBetweenPositions (
  p1: TilePositionXY,
  p2: TilePositionXY,
): number {
  return atan2(p2.y - p1.y, p2.x - p1.x)
}